export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/advantage-global.d834bcbd-10d077.svg";